<template lang="pug">
.success-container
  .success-top
    .safe-area
    .back-box
      .back-btn(@click="goBack")
        img(
          src="https://m.hellobike.com/resource/helloyun/08345/GzXaHiQZ9L.png?x-oss-process=image/quality,q_80",
          style="width: 0.16rem; height: 0.16rem"
        )
    .go-houres(v-if="listData.length>0")
      .go-hourse-block(v-for="(item, index) in listData" :key="index" :class="animateUp?'top30':''")
        .go-houres-img
          img(:src="item.headImg")
        .go-houres-name {{item.nickName}}
        .go-houres-title {{item.title}}
        .go-houres-info {{item.prizeName}}
    .phone-num 已存入尾号{{phoneNum}}账户
    .active-rule(@click="goRule")
    .lottie-block(@click="goBike")
      Lottie.lottie(:url="'https://m.hellobike.com/resource/helloyun/08345/_1dRy9zWIv.json'")
    .active-time
      .active-time-block {{h}}
      .active-time-sign :
      .active-time-block {{m}}
      .active-time-sign :
      .active-time-block {{s}}
      .active-time-sign :
      .active-time-single {{ms}}
      .active-time-word 后活动结束
  .success-bottom
    .success-bottom-title 活动规则
    .success-bottom-block
      p.success-bottom-line 一、邀请及奖励规则
      p.success-bottom-line 1）【邀请人和被邀请人说明】邀请人：历史有过哈啰单车骑行行为的用户；被邀请人：哈啰App新用户&30天内没有登陆过哈啰App的用户
      p.success-bottom-line {{value2}}
      p.success-bottom-line {{value3}}
      p.success-bottom-line 4）【奖励发放】骑行卡奖励会在您的好友完成登陆/单车骑行订单后48小时内发放到您的哈啰账户内，可前往“哈啰出行-钱包-出行卡”查看；
      p.success-bottom-line {{value5}}
      p.success-bottom-line 6）邀请人和被邀请人不能为同一用户，同一哈啰账号、手机号、设备、身份证、微信号、支付宝账号的用户视为同一用户。
      p.success-bottom-line 7）活动中产生的订单必须为真实订单，如产生无效订单，骑行邀请奖励将不发放；
      p.success-bottom-line 8）部分城市及港澳台地区未开通单车服务，请以实际开通情况为准。
      p.success-bottom-line 二、其他说明
      p.success-bottom-line 1.本活动本着公平公开公正的原则，如有用户利用系统漏洞、作弊等违规方式参与活动，将查封用户账号，并有权不发放相关奖励，
      | 同时我司会保留追究相应法律责任的权利。
      p.success-bottom-line 2.本活动与苹果公司无关

</template>
<script>
import Lottie from '@/components/lottie';
import { Native } from '@hb/NBridge/lib/h5';
import { runHorse } from '@/api/mgm';
import { UBTUtils } from '../../../utils/ubt';
import { getTokenAndLocation } from '../../../utils';

export default {
  components: {
    Lottie,
  },
  data() {
    return {
      phoneNum: '',
      h: '',
      m: '',
      s: '',
      ms: 9,
      maxTime: 60 * 60 * 48 * 1000,
      timer: null,
      times: null,
      animateUp: false,
      listData: [],
      value5: '5）【骑行卡详细使用规则】单车7天骑行卡，自领取当日有效，不限骑行次数，每次最多抵扣120分钟，仅限哈啰App使用；单车1天骑行卡，自领取2天内有效，不限骑行次数，每次最多抵扣120分钟，仅限哈啰App使用；',
      value2: '2）【奖励规则】每成功邀请1位好友，好友得1天单车骑行卡，你得8天单车骑行卡：好友完成哈啰App登陆，你得7天单车骑行卡； 好友7天内在哈啰App完成一次单车骑行，你再得1天单车骑行卡，多邀多得，上不封顶。',
      value3: ' 3）【邀请步骤】复制哈口令，分享至微信好友&微信群->好友复制你分享的哈口令->登陆/打开哈啰App，符合被邀请人身份的好友，你们各可领取单车7天骑行卡->好友7天内在哈啰App完成1次单车骑行，你可再领1天单车骑行卡。',
    };
  },
  mounted() {
    UBTUtils.pageView({
      pageId: 'MGMnew_home',
      categoryId: 'platform',
      businessInfo: {},
    });
    this.phoneNum = this.$route.query.phone;
    this.timer = setInterval(() => {
      this.showTime();
      this.maxTime -= 100;
    }, 100);
    this.getHorseList();
    this.times = setInterval(this.scrollAnimate, 3000);
  },
  destroyed() {
    UBTUtils.pageViewOut({
      pageId: 'MGMnew_home',
      categoryId: 'platform',
      businessInfo: {},
    });
    clearInterval(this.timer);
    this.timer = null;
    clearInterval(this.times);
    this.times = null;
  },
  methods: {
    async getHorseList() {
      try {
        const data = await getTokenAndLocation();
        const {
          cityCode,
        } = data;
        const res = await runHorse({
          action: 'user.mgm.prizeList',
          cityCode,
        });
        if (res.data) {
          this.listData = res.data.prizeList;
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('跑马灯', e);
      }
    },
    showTime() {
      if (this.maxTime > 0) {
        const step = -1;
        const t = this.maxTime;
        // eslint-disable-next-line no-console
        // 如果后台给的是毫秒 上面不用除以1000  下面的计算时间也都要除以1000 这里我去掉1000了
        let d = Math.floor(t / 60 / 60 / 24);// 天 var d=Math.floor(t/1000/60/60/24)
        // eslint-disable-next-line no-mixed-operators
        const h = Math.floor((t / 1000 / 60 / 60) % 48);
        // 时 var h=Math.floor(t/1000/60/60%24)
        // eslint-disable-next-line no-mixed-operators
        const m = Math.floor(t / 1000 / 60 % 60);// 分 var m=Math.floor(t/1000/60%60)
        // eslint-disable-next-line no-mixed-operators
        const s = Math.floor(t / 1000 % 60);// 秒 var s=Math.floor(t/1000%60)
        this.ms += step;
        if (this.ms < 0) {
          this.ms = 9;
        }
        if (parseInt(d, 10) < 10) {
          d = `0${d}`;
        }
        if (parseInt(h, 10) < 10) {
          this.h = `0${h}`;
        } else {
          this.h = `${h}`;
        }
        if (parseInt(m, 10) < 10) {
          this.m = `0${m}`;
        } else {
          this.m = `${m}`;
        }
        if (parseInt(s, 10) < 10) {
          this.s = `0${s}`;
        } else {
          this.s = `${s}`;
        }
      } else {
        this.h = '00';
        this.m = '00';
        this.s = '00';
        clearInterval(this.timer);
      }
    },
    goBack() {
      UBTUtils.clickButton({
        pageId: 'MGMnew_home',
        buttonName: 'MGMnew_back',
        categoryId: 'platform',
        businessInfo: {},
      });
      Native.closeWebView();
    },
    goRule() {
      this.$router.push('./rule');
    },
    goBike() {
      UBTUtils.clickButton({
        pageId: 'MGMnew_home',
        buttonName: 'gobike',
        categoryId: 'platform',
        businessInfo: {},
      });
      window.location.href = 'hellobike://hellobike.com/hb/ride/page/home_map?isFlutter=1&bizType=0';
    },
    scrollAnimate() {
      this.animateUp = true;
      setTimeout(() => {
        this.listData.push(this.listData[0]);
        this.listData.shift();
        this.animateUp = false;
      }, 500);
    },
  },
};
</script>
<style lang="less" scoped>
  .top30 {
    transition: all 1.4s;
    margin-top: -0.15rem;
  }

  .back-box {
    .back-btn {
      margin-top: 0.2rem;
      margin-left: 0.1rem;
    }
  }

  .success-container {
    background: #fffbe8;
    position: relative;

    .phone-num {
      margin-top: 2.2rem;
      font-size: 0.13rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #ff8457;
      text-align: center;
    }

    .safe-area {
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      height: 0.33rem;
    }

    .go-houres {
      position: absolute;
      top: 0.48rem;
      height: 0.26rem;
      left: 50%;
      margin-left: -0.99rem;
      width: 1.98rem;
      border-radius: 0.13rem;
      background: #01598c;
      font-size: 0.12rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #fff;
      overflow: hidden;
      line-height: 0.19rem;
      padding-top: 0.04rem;

      .go-hourse-block {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 0.01rem;

        .go-houres-img {
          img {
            width: 0.21rem;
            height: 0.21rem;
            border: 0.01rem solid #fff;
            border-radius: 50%;
          }

          margin-top: -0.02rem;
          margin-left: 0.03rem;
          margin-right: 0.06rem;
        }

        .go-houres-name {
          // margin-top: 0.01rem;
          max-width: 0.48rem;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .go-houres-info {
          // margin-top: 0.01rem;
          margin-left: 0.03rem;
          color: #f0e96b;
        }

        .go-houres-title {
          // margin-top: 0.01rem;
        }
      }
    }

    .active-rule {
      position: absolute;
      right: 0;
      top: 1.5rem;
      height: 0.8rem;
      width: 0.25rem;
    }

    .lottie {
      margin-top: 0.51rem;
    }

    .active-time {
      display: flex;
      justify-content: center;
      font-size: 0.12rem;
      color: #fffbe8;

      .active-time-block {
        background-image: url(https://m.hellobike.com/resource/helloyun/08345/I-F0HCNxzU.png?x-oss-process=image/quality,q_80);
        background-size: 100% 100%;
        width: 0.2rem;
        height: 0.2rem;
        line-height: 0.2rem;
        text-align: center;
      }

      .active-time-single {
        text-align: center;
        line-height: 0.2rem;
        width: 0.1rem;
        height: 0.2rem;
        background-image: url(https://m.hellobike.com/resource/helloyun/08345/4JmhqwIdZ9.png?x-oss-process=image/quality,q_80);
        background-size: 100% 100%;
      }

      .active-time-word {
        margin-left: 0.05rem;
      }
    }

    .success-top {
      height: 5.33rem;
      width: 100%;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/Q_V5Y_B-je.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;

      .safe-area {
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
        height: 0.33rem;
      }
    }

    .success-bottom {
      margin-top: 0.32rem;

      .success-bottom-title {
        text-align: center;
        font-size: 0.18rem;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi, sans-serif;
        font-weight: 500;
        color: rgba(123, 51, 22, 0.75);
        line-height: 0.25rem;
      }

      .success-bottom-block {
        margin-top: 0.2rem;
        padding: 0 0.26rem 0.55rem 0.26rem;
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: rgba(123, 51, 22, 0.75);
        line-height: 0.24rem;
      }
    }
  }
</style>
